import { Relations, UserId } from "@inrev/common";
import { CreateOrUpdateActionItem } from "../components/CreateOrUpdateActionItem";

export const AdminActionItemCreateSection = ({
	isOpen,
	relation,
	defaultUnderwriterId,
	onClose,
}: {
	isOpen: boolean;
	relation: Relations.ActionItems;
	defaultUnderwriterId: UserId;
	onClose?: () => void;
}) => {
	if (!isOpen) return null;

	return (
		<CreateOrUpdateActionItem
			relation={relation}
			defaultUnderwriterId={defaultUnderwriterId}
			onClose={onClose}
		/>
	);
};
